/**
 * Generated by orval v7.7.0 🍺
 * Do not edit manually.
 * RakeBack Wizard API
 * OpenAPI spec version: 1.0.0
 */
import { useMutation } from '@tanstack/react-query'
import type { MutationFunction, UseMutationOptions, UseMutationResult } from '@tanstack/react-query'

import type { SiteTransferRedemptionRequest, SiteTransferRedemptionResponse } from '../models'

import redemptionsRedemptionOptionsSiteTransferRedeemCreateMutator from '../../client'

/**
 * Redeem Edge points for poker room transfer. Users must have unlocked additional redemption options. The request requires a valid poker site ID, username, and Edge amount. Upon successful redemption, a SiteTransferRedemption record is created for manual fulfillment tracking.
 * @summary Redeem Site Transfer
 */
export const redemptionsRedemptionOptionsSiteTransferRedeemCreate = (
  siteTransferRedemptionRequest: SiteTransferRedemptionRequest,
  signal?: AbortSignal,
) => {
  return redemptionsRedemptionOptionsSiteTransferRedeemCreateMutator<SiteTransferRedemptionResponse>(
    {
      url: `/api/v1/redemptions/redemption-options/site-transfer/redeem/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: siteTransferRedemptionRequest,
      signal,
    },
  )
}

export const getRedemptionsRedemptionOptionsSiteTransferRedeemCreateMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof redemptionsRedemptionOptionsSiteTransferRedeemCreate>>,
    TError,
    { data: SiteTransferRedemptionRequest },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof redemptionsRedemptionOptionsSiteTransferRedeemCreate>>,
  TError,
  { data: SiteTransferRedemptionRequest },
  TContext
> => {
  const mutationKey = ['redemptionsRedemptionOptionsSiteTransferRedeemCreate']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof redemptionsRedemptionOptionsSiteTransferRedeemCreate>>,
    { data: SiteTransferRedemptionRequest }
  > = (props) => {
    const { data } = props ?? {}

    return redemptionsRedemptionOptionsSiteTransferRedeemCreate(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type RedemptionsRedemptionOptionsSiteTransferRedeemCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof redemptionsRedemptionOptionsSiteTransferRedeemCreate>>
>
export type RedemptionsRedemptionOptionsSiteTransferRedeemCreateMutationBody =
  SiteTransferRedemptionRequest
export type RedemptionsRedemptionOptionsSiteTransferRedeemCreateMutationError = void

/**
 * @summary Redeem Site Transfer
 */
export const useRedemptionsRedemptionOptionsSiteTransferRedeemCreate = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof redemptionsRedemptionOptionsSiteTransferRedeemCreate>>,
    TError,
    { data: SiteTransferRedemptionRequest },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof redemptionsRedemptionOptionsSiteTransferRedeemCreate>>,
  TError,
  { data: SiteTransferRedemptionRequest },
  TContext
> => {
  const mutationOptions =
    getRedemptionsRedemptionOptionsSiteTransferRedeemCreateMutationOptions(options)

  return useMutation(mutationOptions)
}
